import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { EnrollmentDraft, MasterClientProductViewDto } from '../../../models/api-data-contracts';
import { paymentFrequencyName, calculatePlanRateWithDiscount, enrollmentContactEmail } from '../../../common/helpers';

@Component({
  selector: 'app-confirmation',
  imports: [CommonModule, MatIconModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent {
  @Input({required: true}) member: EnrollmentDraft
  @Input({required: true}) plans: MasterClientProductViewDto[];
  @Input() discountApplied: number = 0;
  @Input() effectiveDate = '';

  get displayEmail(): string {
    return enrollmentContactEmail(this.member);
  }

  planRate(plan: MasterClientProductViewDto){
      return calculatePlanRateWithDiscount([plan], this.member.paymentFrequency ?? 1, this.discountApplied);
    }
    
  paymentFrequency(){
    return paymentFrequencyName(this.member.paymentFrequency ?? 1)
  }
}
